<template>
  <CDataTable
    :items="normalizedRows"
    :fields="fields"
    :items-per-page="50"
    pagination
    hover
    striped
    small
    bordered
  >
    <template #guest_name="{ item }">
      <td>{{ item.guest_name || 'Sin nombre' }}</td>
    </template>

    <template #action="{ item }">
      <td>{{ actionLabel(item.action) }}</td>
    </template>

    <template #status="{ item }">
      <td>
        <CBadge :color="statusColor(item)">
          {{ statusLabel(item.status) }}
        </CBadge>
      </td>
    </template>

    <template #error_message="{ item }">
      <td>{{ item.error_message || '-' }}</td>
    </template>
  </CDataTable>
</template>

<script>
export default {
  name: 'ImportHistoryDetailTable',
  props: {
    rows: { type: Array, default: () => [] }
  },
  computed: {
    normalizedRows() {
      return (this.rows || []).map((row) => ({
        ...row,
        guest_name: row && row.guest_name ? row.guest_name : 'Sin nombre',
        error_message: row && row.error_message ? row.error_message : '-',
      }))
    }
  },
  data() {
    return {
      fields: [
        { key: 'row', label: 'Fila' },
        { key: 'guest_name', label: 'Invitado' },
        { key: 'action', label: 'Acción' },
        { key: 'status', label: 'Estado' },
        { key: 'readable_change', label: 'Detalle' },
        { key: 'error_message', label: 'Error' }
      ]
    }
  },
  methods: {
    actionLabel(action) {
      const labels = {
        created: 'Creado',
        updated: 'Actualizado',
        skipped: 'Ignorado',
        error: 'Error',
      }

      return labels[action] || action || 'Sin acción'
    },
    statusLabel(status) {
      const labels = {
        success: 'Correcto',
        error: 'Error',
      }

      return labels[status] || status || 'Sin estado'
    },
    statusColor(item) {
      if (item.status === 'error') return 'danger'
      if (item.action === 'updated') return 'info'
      if (item.action === 'created') return 'success'
      return 'secondary'
    }
  }
}
</script>
